// extracted by mini-css-extract-plugin
export default {"pill":"Panel_pill__0diEz","spin":"Panel_spin__2r1be"};